export enum Delimiter {
  Comma = ',',
  Space = ' ',
}
